import { getSmoothStepPath, EdgeLabelRenderer, BaseEdge } from 'reactflow';

import styles from './EdgeTypes.module.scss';
import { useReactFlow } from '../functions';
import { EdgeProps } from '../types';
import { CreateNodeFloatingMenuButton, CreateNodeShortcutCommand } from '@/react_app/components';

export default function WorkflowAnimatedHelpEdge({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	style,
}: EdgeProps) {
	const { getEdge } = useReactFlow();
	const edge = getEdge(id);
	const onClick = (shortcut: CreateNodeShortcutCommand) => {
		edge?.data?.onClick(edge, shortcut);
	};
	const showPlusButton = !!edge?.data?.isAllowedToEdit;
	const [edgePath, edgeCenterX, edgeCenterY] = getSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});
	// const plusButtonRadius = plusButtonSize / 2;

	return (
		<>
			<BaseEdge id={id} path={edgePath} style={style} />
			<EdgeLabelRenderer>
				{showPlusButton && (
					<div
						style={{
							position: 'absolute',
							transform: `translate(-50%, -50%) translate(${edgeCenterX}px, ${edgeCenterY}px)`,
							pointerEvents: 'all',
						}}
						className="nodrag nopan"
					>
						<div className="flex-centerize">
							<CreateNodeFloatingMenuButton onShortcutClick={onClick} />
							<div className={styles.addStepText} style={{ position: 'absolute', marginLeft: '175px' }}>
								{'<< Click here to add step'}
							</div>
						</div>
					</div>
				)}
			</EdgeLabelRenderer>
		</>
	);
}
